<template>
  <footer class="footer">
    <img src="@/assets/images/footer.jpg" alt="" srcset="">
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent',
  
}
</script>

<style scoped>

</style>